import { vendey, pipe } from './api.js';
import './vendor/ticket-template-utils.js';

export function kardexField(row, name) {
  const key = Object.keys(row || {}).find(key => key.trim().toUpperCase() === name);
  return key === undefined ? undefined : row[key];
}
function code(value) {
  const number = Number(String(value ?? '').trim());
  return Number.isFinite(number) && number > 0 ? number : 0;
}
export function kardexDocument(row) {
  const purchase = /COMPRA/.test([kardexField(row, 'CTIPOMOVIDESC'), kardexField(row, 'CMOVIMIENTO')].join(' ').toUpperCase()) || code(kardexField(row, 'NCODCOMPRA')) > 0;
  // En compras NCODFACTURA/NCODCOMPRA no identifican el movimiento consultable.
  const id = code(kardexField(row, purchase ? 'NCODPROCESO' : 'NCODFACTURA'));
  return { id, purchase, number: kardexField(row, 'CNUMFACTURA') || `Comprobante ${id}`,
    name: kardexField(row, 'CNOMBRECLIENTE') || '', document: kardexField(row, 'CNUMDOCCLIENTE') || '',
    address: kardexField(row, 'CDIRECCION') || '', date: kardexField(row, 'DFECHAHORA') || kardexField(row, 'DFECHA') || '',
    total: kardexField(row, 'NTOTAL') };
}
function amount(value, fallback = 0) {
  if (value == null || String(value).trim() === '') return fallback;
  const text = String(value).replace(/S\//gi, '').replace(/\s/g, '');
  const number = Number(text.includes('.') ? text.replace(/,/g, '') : text.replace(',', '.'));
  return Number.isFinite(number) ? number : fallback;
}
export function parseKardexReceipt(value, reference) {
  let records;
  if (typeof value === 'string') {
    const [header, ...lines] = value.split('¬');
    const names = header.split('|');
    records = lines.filter(line => line.trim()).map(line => {
      const columns = line.split('|').map(item => item.trim());
      return { columns, row: Object.fromEntries(names.map((name, i) => [name, columns[i]])) };
    });
  } else {
    const rows = Array.isArray(value) ? value : value?.resultado;
    records = Array.isArray(rows) ? rows.map(row => ({ columns: [], row })) : [];
  }
  if (!records.length) throw new Error('El comprobante no contiene detalle para mostrar.');
  const first = records[0];
  const legacy = first.columns.length > 50;
  const header = globalThis.VendeyPlantillaTicket.extraerCabecera(legacy ? first.columns : [], {
    ncodigo: reference.id, comprobantebuscar: reference.number, nombrecliente: reference.name,
    documento: reference.document, direccion: reference.address, fecha: reference.date
  });
  function field(record, names, index) {
    for (const name of names) {
      const value = kardexField(record.row, name);
      if (value != null && String(value).trim() !== '') return value;
    }
    return index === undefined ? undefined : record.columns[index];
  }
  const items = records.map(record => {
    const full = record.columns.length > 50;
    const quantity = amount(field(record, ['NCANTIDAD'], full ? 66 : 2), 1);
    const price = amount(field(record, ['NVAL_UNI', 'NPRECIO', 'NPRECIOUNITARIO'], full ? 58 : undefined), NaN);
    const total = amount(field(record, ['NVENTATOTAL'], full ? 41 : 3), Number.isFinite(price) ? price * quantity : 0);
    return { id: String(field(record, ['NCODPRODUCTO'], full ? 30 : 0) || ''),
      name: String(field(record, ['CPRODUCTODESC', 'CDESCRIPCION'], full ? 31 : 1) || 'Producto'),
      quantity, price: Number.isFinite(price) ? price : quantity > 0 ? total / quantity : 0, total };
  });
  const total = amount(field(first, ['NTOTAL'], legacy ? 18 : undefined), amount(reference.total, items.reduce((sum, item) => sum + item.total, 0)));
  const paid = amount(field(first, ['NMONTOPAGADO'], legacy ? 25 : undefined), total);
  return {
    NCODFACTURA: reference.purchase ? undefined : reference.id, documentId: reference.id, purchase: reference.purchase,
    COMPROBANTE: reference.number, documentTitle: reference.purchase ? 'Comprobante de compra' : header.tipoDocumento,
    company: { name: field(first, ['CNOMBREEMPRESA', 'CRAZONSOCIAL']) || header.razonSocial, ruc: field(first, ['CRUCEMPRESA']) || header.ruc },
    client: { name: field(first, ['CNOMBRECLIENTE']) || header.cliente || 'CLIENTES VARIOS', document: field(first, ['CNUMDOCCLIENTE']) || header.numeroDocumento,
      address: field(first, ['CDIRECCION']) || header.direccionCliente },
    dateText: field(first, ['DFECHAFACTURA']) || header.fecha, seller: field(first, ['CVENDEDOR']) || header.vendedor,
    subtotal: amount(field(first, ['NTOTALBRUTO'], legacy ? 12 : undefined)), tax: amount(field(first, ['NTOTALIGV'], legacy ? 16 : undefined)),
    total, paid, change: Math.max(0, Math.round((paid - total) * 100) / 100),
    totalText: field(first, ['CTOTALTEXTO'], legacy ? 21 : undefined) || '', items
  };
}
export async function loadKardexReceipt(row) {
  const reference = kardexDocument(row);
  if (!reference.id) throw new Error(reference.purchase
    ? 'Comprobante no disponible: la compra no tiene código de movimiento en la consulta.'
    : 'El movimiento no tiene un código de factura válido.');
  const result = await vendey(reference.purchase ? 'spCOM_FACTURATICKETCSVWEB' : 'spVNT_FACTURATICKETCSVWEB', pipe([reference.id, reference.id, '']));
  return parseKardexReceipt(result, reference);
}
